import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { FC, useState, MouseEvent } from "react";
import { AccountCircle } from "@mui/icons-material";
import { useAuthStore } from "service";
import { useNavigate } from "react-router-dom";
import { AdRoutes } from "../../constants/ad-routes";
import { Tokens } from "service";
import { queryClient } from "../../query-client";

const NavbarMenuButton: FC = () => {
  const { setIsLoggedIn } = useAuthStore();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onLogout = () => {
    handleClose();
    Tokens.destroy();
    setIsLoggedIn(false);
    queryClient.clear();
  };

  const onSettings = () => {
    handleClose();
    navigate(AdRoutes.settings);
  };

  return (
    <Box ml="auto">
      <IconButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <AccountCircle />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={onSettings}>Settings</MenuItem>
        <MenuItem onClick={onLogout} data-testid="logout-menuitem">
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default NavbarMenuButton;
